<script>
import { DRAFT_INPUT_TOGGLE, DRAFT_UPDATE } from "@/store/draftmessage.module";
import { mapGetters } from "vuex";
import askAIApi from "@/plugins/ask-ai/services/askai.api";

export default {
  name: "AskAiShortcut",
  data() {
    return {};
  },
  methods: {
    toggleAutoDraft() {
      if (this.isLoading) return;
      const threadId = this.getDialogActive?.id;
      if (!threadId) return;

      const currentVal = this.$store.getters.isAIAutoDraftEnabled(threadId);
      this.$store.commit("AIAutoDraftThread", { threadId, val: !currentVal });
    },

    /**
     * --------------------------------------------------
     * ai get reply suggestion
     * --------------------------------------------------
     */
    async onAskAI() {
      if (this.isLoading) return;
      const threadid = this.getDialogActive.id;
      const subthreadid = this.getDialogActive.subid;

      this.$store.commit(DRAFT_UPDATE, {
        threadid: threadid,
        input_enable: false,
        ai_cancelled: false,
      });
      askAIApi
        .getSuggestion({ subthreadid: subthreadid })
        .then((data) => {
          // --- Cek jika proses dibatalkan staff sebelum API selesai
          if (this.draftMessage && this.draftMessage.ai_cancelled) {
            console.warn(
              `[Ask AI] Manual request for thread ${threadid} was cancelled by user.`
            );
            return;
          }

          const aiContent = data.data.data.content;
          if (threadid === this.getDialogActive.id) {
            this.$emit("apply-suggestion", aiContent);
          }

          this.$store.commit(DRAFT_UPDATE, {
            threadid: threadid,
            id_ask_ai: data.data.data.id,
            message: aiContent,
            is_edited_by_staff: false,
          });
        })
        .catch((error) => {
          const message =
            typeof error.response?.data?.message !== "undefined"
              ? error.response.data.message
              : error.message;
          this.$swal("Error", message, "error");
        })
        .finally(() => {
          this.$store.commit(DRAFT_INPUT_TOGGLE, {
            threadid: threadid,
            input_enable: true,
          });
        });
    },
  },
  computed: {
    ...mapGetters(["isAgentAllowedToAskAI", "getDialogActive"]),
    isAIAutoDraftEnabled() {
      const threadId = this.getDialogActive?.id;
      if (!threadId) return false;
      return this.$store.getters.isAIAutoDraftEnabled(threadId);
    },
    draftMessage() {
      if (!this.getDialogActive?.id) return null;
      return this.$store.getters.getDraftById(this.getDialogActive.id);
    },
    isLoading() {
      return this.draftMessage ? !this.draftMessage.input_enable : false;
    },
  },
  created() {
    this.$store.dispatch("AICheckAgentPermission");
  },
};
</script>

<template>
  <div
    v-if="isAgentAllowedToAskAI"
    class="relative border rounded inline-flex items-center px-1 gap-1 select-none"
  >
    <i
      @click="toggleAutoDraft()"
      class="material-symbols-outlined leading-9"
      :class="{
        'text-muted': !isAIAutoDraftEnabled,
        'cursor-pointer': !isLoading,
        'cursor-not-allowed opacity-50': isLoading,
      }"
      :style="{ color: isAIAutoDraftEnabled && !isLoading ? '#00abe5' : '' }"
      style="font-size: 18px"
      v-b-tooltip.hover
      title="AI Auto Draft"
    >
      {{ isAIAutoDraftEnabled ? "check_box" : "check_box_outline_blank" }}
    </i>
    <div class="h-4 border-l border-gray-300 mx-0.5"></div>
    <i
      @click="onAskAI()"
      class="material-symbols-outlined text-muted leading-9"
      :class="{
        'cursor-pointer': !isLoading,
        'cursor-not-allowed opacity-50': isLoading,
        'animate-spin': isLoading,
      }"
      style="font-size: 18px"
      v-b-tooltip.hover
      title="Tanya AI"
    >
      {{ isLoading ? "sync" : "wand_shine" }}
    </i>
  </div>
</template>
